import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'

import { Text, Button } from 'components/base'
import { Input } from 'components/Utils/Form'
import { providesChannelMutations } from 'components/Channels/dataSync'

import {
  record as ChannelsRecord,
  selectors as ChannelsSelectors,
} from 'data/channels'
import { setActiveModal } from 'data/ui/actions'
import { getActiveModal } from 'data/ui/selectors'
import { canManageChannel } from 'remote/channels/roles'

class ChannelManagement extends Component {
  static propTypes = {
    channel: PropTypes.instanceOf(ChannelsRecord),
    updateChannel: PropTypes.func.isRequired,
    deleteChannel: PropTypes.func.isRequired,
    leaveChannel: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  static defaultProps = {
    onClose: () => {},
  }

  componentWillReceiveProps(newProps) {
    if (newProps.channel.id !== this.props.channel.id) {
      this.props.setChannelName(newProps.channel.name)
    }
  }

  onChannelNameFormSubmit = event => {
    event.preventDefault()
    const { channel, channelName, updateChannel } = this.props
    updateChannel({
      id: channel.id,
      name: channelName,
    })
    this.props.onClose()
  }

  setChannelType = type => {
    const { updateChannel, channel } = this.props
    updateChannel({
      id: channel.id,
      type,
    })
  }

  onChangeDefaultRole = role => {
    const { updateChannel, channel } = this.props
    updateChannel({
      id: channel.id,
      defaultRole: role,
    })
  }

  render() {
    const { channelName, setChannelName, canManage } = this.props

    const onChangeChannelName = e => setChannelName(e.target.value)
    return (
      <div>
        {/* Edit Name */}
        <Text.Section className="margin-bottom-normal">
          Edit channel name
        </Text.Section>
        <div
          className="flexbox flexbox-align-center height-full margin-bottom-larger border-small border-shade-40 radius-normal"
          style={{ paddingRight: 5 }}
        >
          <Input
            className="flexbox-grow border-none"
            value={channelName}
            onChange={onChangeChannelName}
            autoComplete="off"
            disabled={!canManage}
          />
          {canManage && (
            <Button.Primary
              slim
              style={{ minWidth: 0, width: 67 }}
              onClick={this.onChannelNameFormSubmit}
            >
              Update
            </Button.Primary>
          )}
        </div>
      </div>
    )
  }
}

function makeMapStateToProps() {
  const channelAdminCountSelector = ChannelsSelectors.createChannelAdminCountSelector()
  return (state, { channelId }) => {
    const channel = ChannelsSelectors.getChannel(state, channelId)
    const activeModal = getActiveModal(state)
    const numberOfAdmins = channelAdminCountSelector(state, channelId)
    const canManage = canManageChannel({ channel })

    return {
      channel,
      numberOfAdmins,
      activeModal,
      canManage,
    }
  }
}

const mapDispatchToProps = {
  setActiveModal,
}

export default compose(
  providesChannelMutations,
  connect(
    makeMapStateToProps,
    mapDispatchToProps
  ),
  withState('channelName', 'setChannelName', ({ channel }) => channel.name)
)(ChannelManagement)
